export default "__VITE_ASSET__DZgApsKB__"